import React from 'react';
import { cn } from '@/lib/utils';

/** BeThere tab item — underline indicator like `bethere/event-mgt.html` `.tab-nav`. */
export function SectionNavItem({
  index,
  id,
  'aria-controls': ariaControls,
  isSelected,
  handleSelectionChanged,
  title,
  ...props
}) {
  return (
    <button
      {...props}
      id={id}
      type="button"
      role="tab"
      aria-controls={ariaControls}
      aria-selected={isSelected}
      tabIndex={isSelected ? 0 : -1}
      className={cn(
        'relative min-w-0 shrink-0 cursor-pointer border-0 bg-transparent px-0 pb-3 pt-1 text-[length:var(--bethere-f-h6)] font-bold leading-[1.2] transition-colors',
        isSelected
          ? 'text-[var(--bethere-tertiary)] after:absolute after:-bottom-px after:left-0 after:h-[3px] after:w-full after:rounded-[var(--bethere-radius-sm)] after:bg-[var(--bethere-tertiary)]'
          : 'text-[var(--bethere-primary)] hover:text-[var(--bethere-tertiary)]',
      )}
      onClick={() => handleSelectionChanged(index)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleSelectionChanged(index);
        }
      }}
    >
      {title}
    </button>
  );
}
